// Copyright (c) 2017 Deere & Company

import {
    FormattedMessage,
    injectIntl,
    intlShape
} from 'react-intl';
import React, {PropTypes} from 'react';
import {Checkbox} from 'cap-it-ui.toggles';

function handleCheckboxChange() {

    this.onCheckboxChange(!this.isSelected);

}

const UpdateLayoutModalBody = props => {

    const setAsDefault = props.intl.formatMessage({id: 'SET_AS_DEFAULT'});

    return (
        <div className='layout-modal-body'>
            <div className='form-group'>
                <label className='form-group-title'>
                    <FormattedMessage id='LAYOUT_NAME'/>
                </label>
                <div className='current-layout'>{props.layoutName}</div>
            </div>
            <div className='form-group'>
                <Checkbox
                    id='create-layout-set-default'
                    onChange={props::handleCheckboxChange}
                    selected={props.isSelected}
                >
                    {setAsDefault}
                </Checkbox>
            </div>
        </div>
    );

};

UpdateLayoutModalBody.displayName = 'UpdateLayoutModalBody';
UpdateLayoutModalBody.propTypes = {
    intl: intlShape.isRequired,
    isSelected: PropTypes.bool.isRequired,
    layoutName: PropTypes.string.isRequired,
    onCheckboxChange: PropTypes.func.isRequired
};

export default injectIntl(UpdateLayoutModalBody);



// WEBPACK FOOTER //
// ./src/reports/shared/components/report-variant-modals/update-layout-modal/update-layout-modal-body.js